import { API_BASE_URL } from '@/endpoints/apiConfig';
import { AUTHORIZATION_HEADER, ORGANIZATION_HEADER } from '@/session/axiosInterceptors';
import type { RequestScope } from '@/session/scopedTransport';
import { DBImportType } from '@/types/import';

const validate = (importType: string, token: string) => {
  if (!importType) {
    throw new Error('`importType` is required');
  }
  if (!token) {
    throw new Error('`token` is required');
  }
};

type RequestParams = {
  importType: DBImportType;
  token: string;
  accessToken: string | null;
};

export type ImportPreviewCleanupRequest = {
  url: string;
  init: RequestInit;
};

export const buildImportPreviewCleanupRequest = (
  scope: RequestScope,
  { importType, token, accessToken }: RequestParams
): ImportPreviewCleanupRequest => {
  validate(importType, token);

  if (scope.kind !== 'organization') {
    throw new Error('Import preview cleanup requires an organization scope');
  }

  const baseUrl = API_BASE_URL.replace(/\/$/, '');

  const headers: Record<string, string> = {};
  if (accessToken) {
    headers[AUTHORIZATION_HEADER] = `Bearer ${accessToken}`;
  }
  headers[ORGANIZATION_HEADER] = scope.organization;

  return {
    url: `${baseUrl}/import_preview/${importType}/${token}`,
    init: {
      method: 'DELETE',
      keepalive: true,
      credentials: 'include',
      headers,
    },
  };
};
